module.exports = __webpack_public_path__ + "img/classic@2x.9d37a81.webp";